const TimeEntries = () => import('@/views/Application/TimeEntries/TimeEntries');
const FormTimeEntry = () => import('@/views/Application/TimeEntries/FormTimeEntry');
const Expense = () => import('@/views/Application/TimeEntries/Expense');
const Photo = () => import('@/views/Application/TimeEntries/Photo');

export default [
  {
    path: '/dashboard/time-entries',
    name: 'time-entries',
    component: TimeEntries,
    alias: '/dashboard',
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard/time-entries/:id',
    name: 'time-entry',
    component: FormTimeEntry,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard/time-entries/:timeEntryId/photo/:photoId',
    name: 'time-entry-photo',
    component: Photo,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/dashboard/time-entries/:id/expense/:expenseId',
    name: 'time-entry-expense',
    component: Expense,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path:
      '/dashboard/time-entries/:timeEntryId/expense/:expenseId/photo/:photoId',
    name: 'time-entry-expense-photo',
    component: Photo,
    meta: {
      requiresAuth: true,
    },
  },
];
